import {
    LISTAR_CATTIPOCOMPRAS,
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case LISTAR_CATTIPOCOMPRAS:
            return{
                ...state, 
                tiposCompra: action.payload
            }
        default:
            return state
    }
        
}